const allowedUserIds = ["2D9BFUVY", "MN34OP56", "OP12QR34", "C8J1P6DR", "WSORODTJ"]; 

export default allowedUserIds;
